<template>
  <el-button @click="onClick">
    {{ mode === 'view' ? '返 回' : '取 消' }}
  </el-button>
</template>

<script>
export default {
  name: "CancelBtn",
  props: {
    mode: String,
  },
  data() {
    return {};
  },
  methods: {
    onClick() {
      this.$emit("onCancel");
    },
  },
};
</script>

<style lang="less" scoped></style>
